import React from 'react';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useMyContext } from '../../../../context/MyContext';
import { zodResolver } from '@hookform/resolvers/zod';
import axios from 'axios';
import { z } from 'zod';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import ViewRateCalculator from '../../../../component/b2c/models/ViewRateCalculator';
import '../../../../css/custom-scrollbar.css';
import { Base_Url, priceEstimator, getpincode, payment } from '../../../../config/config';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../../../component/spinner/spinner';
import {
  Calculator,
  Zap,
  Package,
  MapPin,
  ArrowRight,
} from 'lucide-react';


const rateCalculatorSchema = z.object({
  pickupPincode: z.string()
    .length(6, "Pickup P  incode must be exactly 6 digits")
    .regex(/^\d+$/, "Pickup pincode must be numeric"),
  dropPincode: z.string()
    .length(6, "Drop Pincode must be exactly 6 digits")
    .regex(/^\d+$/, "Drop Pincode  must be numeric"),
  weight: z.preprocess(
    (val) => (val === '' ? undefined : Number(val)),
    z.number()
      .int("Weight must be a whole number")
      .min(50, "Weight must be at least 50 gm")
  ),
  length: z.string()
    .min(1, "Length is required")
    .regex(/^\d*\.?\d+$/, "Length must be a positive number and can be a float"),
  width: z.string()
    .min(1, "Width is required")
    .regex(/^\d*\.?\d+$/, "Width must be a positive number and can be a float"),
  height: z.string()
    .min(1, "Height is required")
    .regex(/^\d*\.?\d+$/, "Height must be a positive number and can be a float"),
  shipmentType: z.string().optional(),
  declaredValue: z
    .string()
    .optional()
    .refine(value => value === "" || (!isNaN(Number(value)) && Number(value) >= 0), {
      message: "Declared Value must be a non-negative number",
    }),
  prepaid: z.string().nonempty({ message: "Prepaid/COD is required" }),
  cod: z.string().optional(),
});

const RateCalculator = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [data, setData] = useState(null);
  const [prepaidValue, setPrepaidValue] = useState('');
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [pickupCity, setPickupCity] = useState('');
  const [dropCity, setDropCity] = useState('');


  const handlePrepaidChange = (e) => {
    setPrepaidValue(e.target.value);
  };

  const handlePincodeChange = (e, type) => {
    const { value } = e.target;
    const filteredValue = value.replace(/[^0-9]/g, '');
    setValue(type === 'pickup' ? 'pickupPincode' : 'dropPincode', filteredValue);
    if (filteredValue.length === 6) {
      clearErrors(type === 'pickup' ? 'pickupPincode' : 'dropPincode');
    }

    clearCity(type);

    if (filteredValue.length === 6) {
      fetchPincodeData(filteredValue, type)
    }
  };
  const handleNavagation = () => {
    navigate("/dashboard");
  }

  const handleViewClick = () => {
    setIsPopupOpen(true);
  };
  const handleClose = () => {
    setIsPopupOpen(false);
  };
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');
  const { register, handleSubmit, formState: { errors }, reset, watch, setValue, clearErrors } = useForm({
    resolver: zodResolver(rateCalculatorSchema),
  });

  const onSubmit = async (data) => {
    setLoader(true);
    const requestBody = {
      from_pincode: data.pickupPincode,
      to_pincode: data.dropPincode,
      length: parseFloat(data.length),
      width: parseFloat(data.width),
      height: parseFloat(data.height),
      weight: parseFloat(data.weight),
      shipment_type: data.shipmentType,
      declared_value: data.declaredValue ? parseFloat(data.declaredValue) : "",
      payment_mode: data.prepaid,
      cod_amount: data.prepaid === 'cod' ? parseFloat(data.cod) : "",
    };

    try {
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: {
          token,
          cus_id: cusid,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });

      if (response.data.status === "success") {
        setData({ ...response.data, requestWeight: parseFloat(data.weight) });
        reset();
        handleViewClick();
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };
  const clearCity = (type) => {
    if (type === 'pickup') {
      setPickupCity('');
    } else {
      setDropCity('');
    }
  }

  const pickupPincode = watch('pickupPincode');
  const dropPincode = watch('dropPincode');


  useEffect(() => {
    if (pickupPincode && pickupPincode.length === 6) {
      fetchPincodeData(pickupPincode, 'pickup');
    } else {
      clearCity('pickup');
    }
  }, [pickupPincode]);

  useEffect(() => {
    if (dropPincode && dropPincode.length === 6) {
      fetchPincodeData(dropPincode, 'drop');
    } else {
      clearCity('drop');
    }
  }, [dropPincode])


  const handleInputChange = (event) => {
    const { value, id } = event.target;

    if (['length', 'width', 'height'].includes(id)) {
      const filtered = value.replace(/[^0-9]/g, '');
      event.target.value = filtered;
    }
  };

  const fetchPincodeData = async (pincode, type) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;
    try {
      const response = await fetch(urlgetPincode, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      if (data && data.status === "SUCCESS") {
        let { city } = data.data[0];
        city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
        if (type === 'pickup') {
          setPickupCity(city);
        } else {
          setDropCity(city);
        }
      } else {
        clearCity(type);
        toast.error("Failed to fetch city data");
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error("Error fetching pincode data");
    }
  };

  const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.5)]";

  // shared classnames for numeric/text inputs so the "manifest" numerals stay consistent
  const fieldBase = (hasError) =>
    `w-full px-3 py-2 rounded-lg text-sm border transition-all focus:outline-none focus:ring-2 ${
      isDarkMode
        ? 'bg-[#1a1a22] text-white border-white/10 focus:ring-violet-400/40 placeholder:text-white/30'
        : 'bg-gray-50 border-gray-200 focus:bg-white focus:ring-black/20'
    } ${hasError ? 'border-red-400 focus:ring-red-300' : ''}`;

  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'bg-[#08080c]' : 'bg-gray-50'}`}>
        <div className={`pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full blur-3xl ${isDarkMode ? 'bg-[#723EC3]/10' : 'bg-indigo-200/30'}`} />

              <NavBar />
              <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                  <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
                    <Sidebar />
                  </div>
                )}

        <div className={`flex flex-1 flex-wrap lg:flex-nowrap items-stretch gap-2 justify-between p-3 md:p-4 relative z-0 overflow-hidden ${isDarkMode ? 'bg-[#08080c]' : 'bg-gray-100'}`}>

          {/* Left: Form Card */}
          <div className={`w-full lg:w-[48%] rounded-2xl border ${isDarkMode ? 'bg-[#111116] border-white/10 shadow-[0_8px_30px_rgba(0,0,0,0.6)]' : 'bg-white border-gray-200 shadow-[0_8px_30px_rgba(0,0,0,0.08)]'} flex flex-col`}>

            {/* Header — thin vertical rules echo a shipping barcode, not a dot grid */}
            <div className="relative bg-[#723EC3] px-4 py-3 sm:px-5 sm:py-3.5 rounded-t-2xl overflow-hidden flex-shrink-0">
              <div
                className="absolute inset-0 opacity-[0.15]"
                style={{
                  backgroundImage:
                    'repeating-linear-gradient(90deg, white 0px, white 1px, transparent 1px, transparent 3px, white 3px, white 4px, transparent 4px, transparent 9px)',
                }}
              ></div>
              <div className="relative flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-lg bg-white/15 backdrop-blur-sm flex items-center justify-center ring-1 ring-white/30">
                  <Calculator className="w-4 h-4 text-white" />
                </div>
                <div>
                  <h1 className="text-base sm:text-lg font-bold text-white leading-tight">Rate Calculator</h1>
                  <p className="text-[10px] sm:text-[11px] text-white/60">Instant shipping cost estimate</p>
                </div>
              </div>
            </div>

            <form className="p-4 sm:p-5 space-y-3 flex-1 flex flex-col" onSubmit={handleSubmit(onSubmit)}>

              {/* Pincodes */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label htmlFor="pickupPincode" className={`flex items-center gap-1.5 text-xs font-semibold mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
                    <MapPin className={`w-3.5 h-3.5 ${isDarkMode ? 'text-violet-300' : 'text-blue-600'}`} /> Pickup pincode*
                  </label>
                  <input
                    type="text"
                    maxLength="6"
                    id="pickupPincode"
                    placeholder="6-digit pincode"
                    className={`${fieldBase(errors.pickupPincode)} font-mono tabular-nums tracking-wide`}
                    {...register('pickupPincode')}
                    onChange={(e) => handlePincodeChange(e, 'pickup')}
                  />
                  {errors.pickupPincode ? (
                    <p className="text-red-500 text-[11px] mt-1">{errors.pickupPincode.message}</p>
                  ) : (
                    pickupCity && (
                      <p className={`inline-flex items-center gap-1 text-[11px] font-medium mt-1 px-2 py-0.5 rounded-full ${isDarkMode ? 'text-violet-200 bg-violet-400/10' : 'text-gray-800 bg-gray-100'}`}>
                        {pickupCity}
                      </p>
                    )
                  )}
                </div>
                <div>
                  <label htmlFor="dropPincode" className={`flex items-center gap-1.5 text-xs font-semibold mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
                    <MapPin className={`w-3.5 h-3.5 ${isDarkMode ? 'text-amber-300' : 'text-blue-600'}`} /> Drop pincode*
                  </label>
                  <input
                    type="text"
                    id="dropPincode"
                    maxLength="6"
                    placeholder="6-digit pincode"
                    className={`${fieldBase(errors.dropPincode)} font-mono tabular-nums tracking-wide`}
                    {...register('dropPincode')}
                    onChange={(e) => handlePincodeChange(e, 'drop')}
                  />
                  {errors.dropPincode ? (
                    <p className="text-red-500 text-[11px] mt-1">{errors.dropPincode.message}</p>
                  ) : (
                    dropCity && (
                      <p className={`inline-flex items-center gap-1 text-[11px] font-medium mt-1 px-2 py-0.5 rounded-full ${isDarkMode ? 'text-amber-200 bg-amber-400/10' : 'text-gray-800 bg-gray-100'}`}>
                        {dropCity}
                      </p>
                    )
                  )}
                </div>
              </div>

              {/* Perforated tear-line, like the stub on a shipping label */}
              <div className="flex items-center gap-1.5 py-0.5" aria-hidden="true">
                <div className={`w-1.5 h-1.5 rounded-full -ml-[22px] ${isDarkMode ? 'bg-[#08080c] ring-1 ring-white/10' : 'bg-gray-100 ring-1 ring-gray-200'}`} />
                <div className={`flex-1 border-t border-dashed ${isDarkMode ? 'border-white/15' : 'border-gray-300'}`} />
                <div className={`w-1.5 h-1.5 rounded-full -mr-[22px] ${isDarkMode ? 'bg-[#08080c] ring-1 ring-white/10' : 'bg-gray-100 ring-1 ring-gray-200'}`} />
              </div>

              {/* Dimensions & Weight */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label className={`flex items-center gap-1.5 text-xs font-semibold mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
                    <Package className={`w-3.5 h-3.5 ${isDarkMode ? 'text-violet-300' : 'text-red-600'}`} /> Dimensions (cm)*
                  </label>
                  <div className="grid grid-cols-3 gap-2">
                    <input
                      type="text"
                      id='length'
                      step="0.01"
                      placeholder="L"
                      className={`${fieldBase(errors.length)} text-center font-mono tabular-nums`}
                      {...register('length')}
                      onChange={handleInputChange}
                    />
                    <input
                      type="text"
                      step="0.01"
                      id='width'
                      placeholder="W"
                      className={`${fieldBase(errors.width)} text-center font-mono tabular-nums`}
                      {...register('width')}
                      onChange={handleInputChange}
                    />
                    <input
                      type="text"
                      id='height'
                      placeholder="H"
                      step="0.01"
                      className={`${fieldBase(errors.height)} text-center font-mono tabular-nums`}
                      {...register('height')}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.length && <p className="text-red-500 text-[11px] mt-1">{errors.length.message}</p>}
                </div>
                <div>
                  <label htmlFor="weight" className={`flex items-center gap-1.5 text-xs font-semibold mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
                    <Zap className={`w-3.5 h-3.5 ${isDarkMode ? 'text-amber-300' : 'text-yellow-500'}`} /> Weight (g)*
                  </label>
                  <input
                    id="weight"
                    type="number"
                    step="0.01"
                    placeholder="e.g. 500"
                    className={`${fieldBase(errors.weight)} font-mono tabular-nums`}
                    {...register('weight')}
                  />
                  {errors.weight && <p className="text-red-500 text-[11px] mt-1">{errors.weight.message}</p>}
                </div>
              </div>

              {/* Shipment type & Declared value */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label htmlFor="shipmentType" className={`block text-xs font-semibold mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
                    Shipment type
                  </label>
                  <select
                    id="shipmentType"
                    className={fieldBase(errors.shipmentType)}
                    {...register('shipmentType')}
                  >
                    <option value="">Select shipment type</option>
                    <option value="Forward">Forward</option>
                  </select>
                  {errors.shipmentType && <p className="text-red-500 text-[11px] mt-1">{errors.shipmentType.message}</p>}
                </div>
                <div>
                  <label htmlFor="declaredValue" className={`block text-xs font-semibold mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
                    Declared value
                  </label>
                  <input
                    type="text"
                    id="declaredValue"
                    placeholder="₹ amount"
                    className={`${fieldBase(errors.declaredValue)} font-mono tabular-nums`}
                    {...register('declaredValue')}
                  />
                  {errors.declaredValue && <p className="text-red-500 text-[11px] mt-1">{errors.declaredValue.message}</p>}
                </div>
              </div>

              {/* Prepaid / COD */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label htmlFor="prepaid" className={`block text-xs font-semibold mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
                    Prepaid/COD*
                  </label>
                  <select
                    id="prepaid"
                    className={fieldBase(errors.prepaid)}
                    {...register('prepaid')}
                    onChange={handlePrepaidChange}
                  >
                    <option value="">Select Prepaid/COD</option>
                    <option value="prepaid">Prepaid</option>
                    <option value="cod">COD</option>
                  </select>
                  {errors.prepaid && <p className="text-red-500 text-[11px] mt-1">{errors.prepaid.message}</p>}
                </div>
                {prepaidValue === 'cod' && (
                  <div>
                    <label htmlFor="cod" className={`block text-xs font-semibold mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
                      COD amount*
                    </label>
                    <input
                      id="cod"
                      type="text"
                      placeholder="₹ amount"
                      className={`${fieldBase(errors.codAmount)} font-mono tabular-nums`}
                      {...register('cod')}
                    />
                    {errors.cod && <p className="text-red-500 text-[11px] mt-1">{errors.cod.message}</p>}
                  </div>
                )}
              </div>

              <div className="flex-1"></div>

              <button
                type="submit"
                disabled={loader}
                className={`w-full flex items-center justify-center gap-2 bg-[#723EC3] text-white text-sm font-semibold px-6 py-2.5 rounded-lg shadow-md shadow-black/20 transition-all disabled:opacity-70 ${isDarkMode ? 'hover:bg-[#8452d9]' : 'hover:bg-gray-800'}`}
              >
                {loader ? <Spinner /> : (
                  <>
                    Calculate rate <ArrowRight className="w-4 h-4" />
                  </>
                )}
              </button>
            </form>
          </div>

          {/* Right: Route panel */}
          <div className="w-full lg:w-[48%] hidden lg:flex flex-col relative rounded-2xl overflow-hidden">
            <div className={`absolute inset-0 ${isDarkMode ? 'bg-[#3d2270]' : 'bg-[#723EC3]'}`}></div>
            <div
              className="absolute inset-0 opacity-[0.12]"
              style={{
                backgroundImage:
                  'repeating-linear-gradient(90deg, white 0px, white 1px, transparent 1px, transparent 3px, white 3px, white 4px, transparent 4px, transparent 9px)',
              }}
            ></div>

            <div className="relative z-10 flex-1 flex flex-col p-5 xl:p-6 overflow-hidden">
              <div className="mb-4 flex-shrink-0">
                <h2 className="text-xl xl:text-2xl font-bold text-white leading-snug">
                  Shipping made simple
                </h2>
                <div className="w-14 h-1 bg-white/40 rounded-full mt-2"></div>
              </div>

              {/* Route: pickup -> image -> drop, tied to live form state */}
              <div className="flex-1 flex gap-4 min-h-0">
                <div className="flex flex-col items-center pt-1 pb-1">
                  <div className="w-2.5 h-2.5 rounded-full bg-white ring-4 ring-white/20 flex-shrink-0"></div>
                  <div
                    className="flex-1 w-px my-1"
                    style={{
                      backgroundImage:
                        'repeating-linear-gradient(to bottom, rgba(255,255,255,0.55) 0 4px, transparent 4px 9px)',
                    }}
                  ></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-amber-300 ring-4 ring-amber-300/20 flex-shrink-0 animate-pulse"></div>
                </div>

                <div className="flex-1 flex flex-col min-h-0">
                  <div>
                    <p className="text-[11px] text-white/55">Pickup</p>
                    <p className="text-sm font-semibold text-white truncate">{pickupCity || 'Your city'}</p>
                  </div>

                  <div className="relative w-full max-w-[220px] my-3 mx-auto flex-shrink min-h-0">
                    <div className="relative rounded-xl overflow-hidden shadow-2xl ring-1 ring-white/20">
                      <img
                        src="/assets/images/ratecalculator.png"
                        alt="Rate Calculator"
                        className="w-full h-auto object-cover grayscale"
                      />
                      <div className="absolute bottom-0 left-0 right-0 h-1 bg-amber-300"></div>
                    </div>
                  </div>

                  <div>
                    <p className="text-[11px] text-white/55">Drop</p>
                    <p className="text-sm font-semibold text-white truncate">{dropCity || 'Destination'}</p>
                  </div>
                </div>
              </div>

              {/* Stats — hairline-divided, not another row of icon cards */}
              <div className="grid grid-cols-3 divide-x divide-white/15 border-t border-white/15 pt-3 mt-3 flex-shrink-0">
                <div className="text-center px-1.5">
                  <p className="text-base xl:text-lg font-bold text-amber-300 tabular-nums">10,000+</p>
                  <p className="text-[10.5px] text-white/60 mt-0.5 leading-tight">businesses shipping with us</p>
                </div>
                <div className="text-center px-1.5">
                  <p className="text-base xl:text-lg font-bold text-amber-300 tabular-nums">&lt;2s</p>
                  <p className="text-[10.5px] text-white/60 mt-0.5 leading-tight">to get a quote</p>
                </div>
                <div className="text-center px-1.5">
                  <p className="text-base xl:text-lg font-bold text-amber-300 tabular-nums">100%</p>
                  <p className="text-[10.5px] text-white/60 mt-0.5 leading-tight">accurate, no hidden fees</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ViewRateCalculator isopen={isPopupOpen} onClose={handleClose} data={data} />
    </div>
  );
};

export default RateCalculator;